import {
  Button,
  ErrorMessage,
  Spinner,
  SuccessPopup,
} from "@/common/components";
import { useContext, useEffect, useState, useCallback } from "@/common/hooks";
import ContactInformation from "@/components/Common/ContactInformation";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useSaveProductManufacturerForAdminMutation,
  useUpdateProductManufacturerForAdminMutation,
} from "@/service/AdminService";
import { useGetStatesForEnrollmentQuery } from "@/service/APIService";

const ProductManufacturerDetails = () => {
  const {
    setNavHeader,
    location,
    debounceState,
    debounceErrors,
    cancel,
    labels,
    setPageHeader,
  } = useContext(PrivateContext);
  const [contactInfo, setContactInfo] = useState({});
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const {
    data: states,
    isFetching: isFetching,
    error: error,
  } = useGetStatesForEnrollmentQuery();

  const [
    updateProductManufacturerApi,
    { isLoading: isFetching1, error: error1 },
  ] = useUpdateProductManufacturerForAdminMutation();

  const [
    saveProductManufacturerApi,
    { isLoading: isFetching2, error: error2 },
  ] = useSaveProductManufacturerForAdminMutation();

  const checkDisabled = useCallback(() => {
    let disable = false;

    Object.keys(errors).forEach((e) => {
      if (errors[e]) {
        disable = true;
      }
    });

    if (disable) {
      return true;
    }

    const requiredFields = [
      "externalId",
      "name",
      "addressLine1",
      "city",
      "zipCode",
      "phoneNumber",
      "email",
      "confirmEmail",
    ];

    requiredFields.forEach((e) => {
      if (!contactInfo[e]) {
        disable = true;
      }
    });

    return disable;
  }, [errors]);

  const addOrUpdatePMDetails = () => {
    // Update
    if (location?.state) {
      updateProductManufacturerApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
    // Add New
    else {
      saveProductManufacturerApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
  };

  useEffect(() => {
    setPageHeader(labels?.productManufacturer?.productManufacturerDetails);
    setNavHeader(labels?.productManufacturer?.productManufacturer);

    if (location?.state) {
      setContactInfo(location?.state);
    }
    labels.productManufacturer.email = labels.productManufacturer.adminEmail;
  }, []);

  return (
    <section className="container-medium py-5">
      {(isFetching || isFetching1 || isFetching2) && <Spinner />}
      <ErrorMessage error={error || error1 || error2} wrapperClassName="mb-3" />
      <ContactInformation
        showHeading={false}
        showNames={false}
        showCellPhone={false}
        showExternalId={true}
        showCompanyName={true}
        showWebsite={true}
        showExtension={false}
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
        states={states}
        errors={errors}
        setErrors={setErrors}
        touched={touched}
        setTouched={setTouched}
        debounceErrors={debounceErrors}
        debounceState={debounceState}
        labels={labels?.productManufacturer}
      />

      <div className="d-flex flex-row gap-1 justify-content-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.productManufacturer?.cancel}
          wrapperClassName="col-md-4 col-6"
          click={cancel}
        />
        <Button
          id="done"
          text={
            location?.state
              ? labels?.productManufacturer?.update
              : labels?.productManufacturer?.submit
          }
          wrapperClassName="col-md-4 col-6"
          disabled={checkDisabled()}
          click={addOrUpdatePMDetails}
        />
      </div>
      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.productManufacturer?.continue}
        click={cancel}
        body={labels?.productManufacturer?.requestCompleted}
      />
    </section>
  );
};

export default ProductManufacturerDetails;
